import React, { useState } from 'react';
import contactBg from '../../assets2/backgrounds/contact-bg.png';
import Loading from '../common/Loading';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbyuFBd0Awkwj1QW6f_Frril56rwVi_qBzBF7gO6l4FUIciMaIdz0NiqwTMIo26UsEn2jQ/exec', {
        method: 'POST',
        headers: {
          "Content-Type": "text/plain;charset=utf-8"
        },
        body: JSON.stringify(formData),
        redirect: 'follow'
      });

      const result = await response.json();

      if (result.result === 'success') {
        alert('Thank you for joining our newsletter!');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        alert('There was an error submitting the form. Please try again.');
      }
    } catch (error) {
      console.error('Submission error', error);
      alert('There was an error submitting the form. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading />
  }

  return (
    <div className="contact-container">
      <div className="contact-hero">
        <div className="contact-hero-background">
          <img src={contactBg} alt="Contact Background" />
          <div className="contact-hero-overlay"></div>
        </div>
        <div className="contact-hero-content">
          <h1>Join the Newsletter</h1>
          <p>Stay updated with the latest news and updates from Canopy Systems</p>
        </div>
      </div>
      
      <div className="contact-content">
        <div className="contact-grid">
          <div className="contact-form-section">
            <h2>Newsletter Signup</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                ></textarea>
              </div>
              
              <button type="submit" className="submit-btn">
                Join Newsletter
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
